import { Component, OnInit } from '@angular/core';
import { Curso } from 'src/app/project/interfaces/curso';
import { Postulacion } from 'src/app/project/interfaces/postulacion';
import { CursosService } from 'src/app/project/services/cursos.service';
import { PostulacionesService } from 'src/app/project/services/postulaciones.service';
import { StartService } from 'src/app/project/services/start.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CertificadosService } from 'src/app/project/services/certificados.service';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public numPostulaciones: number = 0;
  public numPostulacionesAceptadas: number = 0;
  public numPostulacionesMes: number = 0;
  public numCursosEnProgreso: number = 0;
  public numCertificadosAlumno: number = 0;

  public loadingPostulaciones: boolean = true;
  public loadingPostulacionesAceptadas : boolean = true;
  public loadingPostulacionesMes: boolean = true;
  public loadingCursosEnProgreso: boolean = true;
  public loadingCertificados: boolean = true;

  public videos: any[] = [];

  constructor(
    private postulacionesService: PostulacionesService,
    private cursosService: CursosService,
    private startService: StartService,
    private sanitizer: DomSanitizer,
    private certificadosService: CertificadosService,
    private erroresHandler: ErroresHandler
  ) { }

  ngOnInit(): void {
    this.postulacionesService.obtenerPostulacionesUsuario().then( (postulaciones: Postulacion[]) => {
      postulaciones.forEach((postulacion: Postulacion) => {       
        if(new Date(postulacion.fechaPostulacion).getUTCMonth() == new Date().getUTCMonth()){
          this.numPostulacionesMes += 1;
        }
      });  
      setTimeout(() => {
        this.loadingPostulacionesMes = false; 
      }, 500);
        
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pudo obtener información sobre postulaciones',
          'Error'
      );
  });

    this.cursosService.obtenerCursosUsuario().then( (cursos: Curso[]) => {
      cursos.forEach( (curso: Curso) => {
        if( curso.estado == 'ACTIVO' ){
          this.numCursosEnProgreso += 1;
        }
      });
      setTimeout(() => {        
        this.loadingCursosEnProgreso = false;
      }, 500);

    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pudo obtener información sobre cursos',
          'Error'
      );
  });

    this.postulacionesService.getCantidadPostulacionesAlumno().then(data => {
      this.numPostulaciones = data;
      setTimeout(() => {    
        this.loadingPostulaciones = false;
      }, 500);

    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pudo obtener información sobre postulaciones',
          'Error'
      );
  });

    this.postulacionesService.getCantidadPostulacionesAceptadasAlumno().then(data => {
      this.numPostulacionesAceptadas = data;
      setTimeout(() => {    
        this.loadingPostulacionesAceptadas = false;
      }, 500);

    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pudo obtener información sobre postulaciones',
          'Error'
      );
  });

    this.certificadosService.getCantidadCertificadosAlumno().then(data => {
      
      this.numCertificadosAlumno = data;
      setTimeout(() => {    
        this.loadingCertificados = false;
      }, 500);

    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pudo obtener información sobre certificados',
          'Error'
      );
  });

    this.startService.getVideosTutoriales().then(videos => {
      videos.forEach(video => {
        if(!video.mostrar_home && video.estado){
          let url = 'https://www.youtube.com/embed/' + video.id_video;
          video.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);          
          this.videos.push(video);
        }
      });
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'alert',
          'No se pudieron cargar los tutoriales',
          'Error'
      );
  });

  }

}
